import React, { useState, useEffect } from 'react';
import { Skeleton, Row, Tabs } from 'antd';
import { BicycleParkingSpotCard } from './BicycleParkingSpotCard';
import { BicycleParkingSpotMoreInfo } from './BicycleParkingSpotMoreInfo';
import { bicycleParkingService } from '../../services';
import { OmitProps } from 'antd/lib/transfer/ListBody';

const { TabPane } = Tabs;

export const BicycleParkingSpotInfo = ({ bicycleParkingSpot,setShowBicycleParkingVisible,onEditLocation,  ...otherProps }) => {
  const [bicycleParkingData, setBicycleParkingData] = useState([]);
  const [bicycleParkingInfo, setBicycleParkingInfo] = useState(false);

  useEffect(() => {
    if (!bicycleParkingSpot) {
      return;
    }

    let bicycleParkingSpotSupply = [];
    let bicycleParkingSpotDemand = [];

    bicycleParkingSpot.forEach((id) => {
      if (id.typeOfRequest === 'bicycle_parking_supply_user') {
        bicycleParkingSpotSupply.push(id);
      } 
      else if (id.typeOfRequest === 'bicycle_parking_demand_user') {
        bicycleParkingSpotDemand.push(id);
      } 
      else {
        console.log('Error while loading:', id);
      }
    });

    setBicycleParkingData([bicycleParkingSpotSupply, bicycleParkingSpotDemand]);

    async function getSpotInfo(id) {
      const bicycleParking = await bicycleParkingService.getBicycleParking(id);
      setBicycleParkingInfo(bicycleParking);
    }

    getSpotInfo(bicycleParkingSpot[0].id);
  }, [otherProps.onDataUpdate]);


  if (!bicycleParkingSpot) {
    return <Skeleton active />;
  }

  if (bicycleParkingSpot.length === 1) {
    return (
      <>
        <Row>
          <p className="bicycleParkingSpotInfoTitle">Detaljne informacije</p>
          <BicycleParkingSpotMoreInfo 
          bicycleParkingSpot={bicycleParkingSpot} 
          onDataUpdate={otherProps.onDataUpdate}
          setShowBicycleParkingVisible={setShowBicycleParkingVisible}
          onEditLocation={onEditLocation}
          />
        </Row>
      </>
    );
  }

  return (
                <Tabs defaultActiveKey="1">
                        
                        <TabPane tab="Ponuda" key="1">
							{bicycleParkingData&& bicycleParkingData[0] && bicycleParkingData[0].length>0&&bicycleParkingData[0].map((id)=>
                            <BicycleParkingSpotCard
                            bicycleParkingSpotType={id.details.bicycle_stand_type|| `Stalak za romobile`}
                            bicycleParkingPhoto={id.details.photo}
                            bicycleParkingSpotID={id.id}                            
                            onDataUpdate={otherProps.onDataUpdate}
                            setShowBicycleParkingVisible={setShowBicycleParkingVisible}
                            onEditLocation={onEditLocation}
                            >				
                            </BicycleParkingSpotCard> )

                       || bicycleParkingSpot.length&&<p className='noSelectedParkingSpotMessage'>Odabrana lokacija nema točke ponude</p>}
                        </TabPane>

                        <TabPane tab="Potražnja" key="2">
							{bicycleParkingData&& bicycleParkingData[1] && bicycleParkingData[1].length>0&&bicycleParkingData[1].map((id)=>
                            <BicycleParkingSpotCard
                            bicycleParkingSpotType={id.details.bicycle_stand_type_demand|| `alternativna potražnja za stalkom za ${id.details.transportation_vehicle_demand}`}
                            bicycleParkingPhoto={id.details.photo_alternative_demand|| id.details.photo_existing_demand}
                            bicycleParkingSpotID={id.id}
                            onDataUpdate={otherProps.onDataUpdate}
                            setShowBicycleParkingVisible={setShowBicycleParkingVisible}
                            onEditLocation={onEditLocation}
                            >				
                            </BicycleParkingSpotCard>)
                            
                            || bicycleParkingSpot.length&&<p className='noSelectedParkingSpotMessage'>Odabrana lokacija nema točke potražnje</p>}
                        </TabPane>
						
					</Tabs>)}